export default "__VITE_ASSET__CzR$7gkI__"